import React from "react";
import {
  Input,
  FormLabel,
  Textarea,
  Box,
  Checkbox,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Stack,
} from "@chakra-ui/react";
import SearchIcon from "../../../assets/iconz/Search.png";
import { InputGroup } from "react-bootstrap";

const Announcement = ({ formHandler }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const listOfPrograms = [
    "Entrepreneurship Program",
    "Intro to Design",
    "Accounting 101",
    "Accounting 101",
  ];
  return (
    <div>
      <h2>
        This will show up as notifications for users enrolled in this program
      </h2>
      <Box mt={6}>
        <FormLabel htmlFor="title">Announcement Title</FormLabel>

        <Input
          variant="filled"
          type="text"
          placeholder="Enter Title"
          size="lg"
          id="announcementTitle"
          name="announcementTitle"
          onChange={formHandler.handleChange}
          value={formHandler.values.announcementTitle}
          isRequired
        />
      </Box>
      <Box mt={6}>
        <FormLabel htmlFor="learn">Announcement details</FormLabel>
        <Textarea
          placeholder="Announcement details"
          variant="filled"
          size="sm"
          id="announcementDetails"
          name="announcementDetails"
          onChange={formHandler.handleChange}
          value={formHandler.values.announcementDetails}
          isRequired
        />
      </Box>

      <Stack mt="20">
        <Checkbox>Send to multiple programs</Checkbox>
        <Checkbox>
          Send email to users who were enrolled when announcement was created
        </Checkbox>
      </Stack>

      <Box textAlign="end" m="3">
        <Button onClick={onOpen}>Select Program</Button>
      </Box>
      {isOpen && (
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Program List</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <InputGroup mb="3">
                <SearchIconComponent />
                <Input placeholder="Search" size="md" />
              </InputGroup>
              <Stack spacing={10} mt={3} direction="column">
                {listOfPrograms.map((program) => (
                  <Checkbox
                    key={program}
                    mt="0 !important"
                    border="1px"
                    borderColor="gray.200"
                    borderStyle="dashed"
                    py="3"
                  >
                    {program}
                  </Checkbox>
                ))}
              </Stack>
            </ModalBody>

            <ModalFooter>
              <Button bg="#213C5C" color="white" mr={3} onClick={onClose}>
                Assign
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default Announcement;

const SearchIconComponent = () => (
  <img
    src={SearchIcon}
    alt="search"
    style={{ position: "absolute", top: "16%", right: "0" }}
  />
);
